import React from "react"
import { useTranslation } from "react-i18next"

import classes from "./KtOrderHeader.module.scss"

const KtOrderHeader = props => {
  const { tableOrder, isOrderSplited } = props

  const [t] = useTranslation()

  return (
    <div className={classes["code"]}>
      {t("سفارش")} {tableOrder.code}{" "}
      {
        isOrderSplited &&
        <span className={classes["splited"]}>
          ({t("جدا_شده")})
        </span>
      }
    </div>
  )
}

export default KtOrderHeader